import request from '../../request'
import {questions} from '../../endpoints'

export default class questionsApi {
  static async post(data) {
    return request({
      url: questions.post(),
      method: 'POST',
      data: data,
    })
  }

  static async get(id) {
    return request({
      url: questions.get(id),
      method: 'GET',
    })
  }
  static async getAll(id) {
    return request({
      url: questions.getAll(id),
      method: 'GET',
    })
  }

  static getBySubCatId(id) {
    return request({
      url: questions.getBySubCatId(id),
      method: 'GET',
    })
  }

  static getListByIds(ids) {
    return request({
      url: questions.getListByIds(),
      method: 'post',
      data: ids,
    })
  }
  static getQuestionsByTagId(id, audience, isAdmin) {
    let customer = JSON.parse(localStorage.getItem('customer'))
    return request({
      url: questions.getQuestionsByTagId(id, audience, isAdmin, customer.name),
      method: 'GET',
    })
  }
  static async getQuestionForParticipants(token, language) {
    return request({
      url: questions.getQuestionForParticipants(language),
      method: 'POST',
      data: token,
    })
  }

  static async getQuestionsByTagIdAndSearch(search, audience, isAdmin, ids) {
    return request({
      url: questions.getQuestionsByTagIdAndSearch(search, audience, isAdmin),
      method: 'POST',
      data: ids,
    })
  }
  static async getSurveyQuestionsByTagId(schoolId, matId, tagId, audience) {
    return request({
      url: questions.getSurveyQuestionsByTagId(
        schoolId,
        matId,
        tagId,
        audience
      ),
      method: 'GET',
    })
  }
}
